import { WHERE } from 'src/utils/firebase/firebase-manager';
import { getProductSupplierPurchaseOrders } from 'src/utils/firebase/firebase-short-cut';
import useSWRImmutable from 'swr/immutable';

const fetchProductSupplierPurchaseOrders = (where: WHERE[]) => getProductSupplierPurchaseOrders(where);

const useSWRProductSupplierPurchaseOrders = (where: WHERE[] | null) => {
  const {
    data: productSupplierPurchaseOrders,
    isLoading,
    mutate,
  } = useSWRImmutable(
    where ? `productSupplierPurchaseOrders-${where}` : null,
    () => fetchProductSupplierPurchaseOrders(where as WHERE[]),
    {
      errorRetryCount: 2,
    }
  );

  return {
    productSupplierPurchaseOrders,
    isLoading,
    refresh: () => mutate(undefined, { revalidate: true }),
  };
};

export default useSWRProductSupplierPurchaseOrders;
